import { createContext } from 'react';

import {
  ApprovalProcessStateContext,
  type ApprovalProcessDispatchContext,
} from './types';

export const initialState: ApprovalProcessStateContext = {
  isPending: true,
  isError: false,
  data: null,
};

export const CircuitStateContext =
  createContext<ApprovalProcessStateContext | null>(null);
export const CircuitDispatchContext =
  createContext<ApprovalProcessDispatchContext | null>(null);
